import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import './nav.css';

// 워크스페이스 전체 셸: 왼쪽 사이드바 + 오른쪽 메인(자식 라우트 Outlet).
// 모바일(<=820px)에서는 사이드바를 드로어로 접고 햄버거 버튼으로 토글한다.
export default function WorkspaceLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // 라우트 이동 시 모바일 드로어 자동 닫기.
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className="nav-shell">
      <div
        className={`nav-backdrop${drawerOpen ? ' show' : ''}`}
        onClick={() => setDrawerOpen(false)}
      />
      <Sidebar mobileOpen={drawerOpen} onNavigate={() => setDrawerOpen(false)} />

      <div className="nav-main">
        <div className="nav-main-bar">
          <button
            type="button"
            className="nav-hamb"
            aria-label="메뉴 열기"
            onClick={() => setDrawerOpen((v) => !v)}
          >
            ☰
          </button>
        </div>
        <div className="nav-main-scroll">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
